import { render, staticRenderFns } from "./redeem-list.vue?vue&type=template&id=605fe484&"
import script from "./redeem-list.vue?vue&type=script&lang=js&"
export * from "./redeem-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports